module.exports = __webpack_public_path__ + "assets/textures/violin_tex_roughness.8a6d0abdb3322a7f76a2841d81284c56.jpg";